import { Button, Tabs, Space, Modal } from 'antd';
import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import '../../style/investment_idea.css';

const ReportContentModalView = ({ ticker, report, onClose, open }) => {
    const [reportData, setReportData] = useState(null);

    useEffect(() => {
        if (report) {
            setReportData(JSON.parse(report));
        }
    }, [report])

    const drawTitle = () => {
        return `${ticker} Report Content`
    }

    return (
        <div>
            <Modal
                title={drawTitle()}
                width={720}
                mask
                onCancel={onClose}
                open={open}
                styles={{
                    body: {
                        paddingTop: 32,
                    },
                }}
                footer={
                    <Space>
                        <Button onClick={onClose}>Close</Button>
                    </Space>
                }
            >
                <Tabs>
                    <Tabs.TabPane tab="Summary" key="1">
                        <div style={{ maxHeight: '60vh', overflow: 'auto', fontSize: 14, lineHeight: 1.5 }}>
                            <div className='report-aspect-item'>
                                <ReactMarkdown key='summary' remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{reportData?.summary}</ReactMarkdown>
                            </div>
                        </div>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Content" key="2">
                        <div style={{ maxHeight: '60vh', overflow: 'auto', fontSize: 14, lineHeight: 1.5 }}>
                            <div className='report-aspect-item'>
                                <ReactMarkdown key='content' remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{reportData?.content}</ReactMarkdown>
                            </div>
                        </div>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={`Fundamental: ${reportData?.fundamental_sentiment}`} key="3">
                        <div style={{ maxHeight: '60vh', overflow: 'auto', fontSize: 14, lineHeight: 1.5 }}>
                            <h3>Summary</h3>
                            <div className='report-aspect-item'>
                                <ReactMarkdown key='fundamental_summary' remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{reportData?.fundamental_summary}</ReactMarkdown>
                            </div>
                            <h3>Detail</h3>
                            <div className='report-aspect-item'>
                                <ReactMarkdown key='fundamental_detail' remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{reportData?.fundamental_detail}</ReactMarkdown>
                            </div>
                        </div>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={`Technical: ${reportData?.technical_sentiment}`} key="4">
                        <div style={{ maxHeight: '60vh', overflow: 'auto', fontSize: 14, lineHeight: 1.5 }}>
                            <h3>Summary</h3>
                            <div className='report-aspect-item'>
                                <ReactMarkdown key='technical_summary' remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{reportData?.technical_summary}</ReactMarkdown>
                            </div>
                            <h3>Detail</h3>
                            <div className='report-aspect-item'>
                                <ReactMarkdown key='technical_detail' remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{reportData?.technical_detail}</ReactMarkdown>
                            </div>
                        </div>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={`Macro: ${reportData?.macro_sentiment}`} key="5">
                        <div style={{ maxHeight: '60vh', overflow: 'auto', fontSize: 14, lineHeight: 1.5 }}>
                            <h3>Summary</h3>
                            <div className='report-aspect-item'>
                                <ReactMarkdown key='macro_summary' remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{reportData?.macro_summary}</ReactMarkdown>
                            </div>
                            <h3>Detail</h3>
                            <div className='report-aspect-item'>
                                <ReactMarkdown key='macro_detail' remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{reportData?.macro_detail}</ReactMarkdown>
                            </div>
                        </div>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={`News and Social: ${reportData?.social_sentiment}`} key="6">
                        <div style={{ maxHeight: '60vh', overflow: 'auto', fontSize: 14, lineHeight: 1.5 }}>
                            <h3>Summary</h3>
                            <div className='report-aspect-item'>
                                <ReactMarkdown key='social_summary' remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{reportData?.social_summary}</ReactMarkdown>
                            </div>
                            <h3>Detail</h3>
                            <div className='report-aspect-item'>
                                <ReactMarkdown key='social_detail' remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{reportData?.social_detail}</ReactMarkdown>
                            </div>
                        </div>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Recommendation" key="7">
                        <div style={{ maxHeight: '60vh', overflow: 'auto', fontSize: 14, lineHeight: 1.5 }}>
                            <div className='report-aspect-item'>
                                <ReactMarkdown key='recommended_action' remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{reportData?.recommended_action}</ReactMarkdown>
                            </div>
                        </div>
                    </Tabs.TabPane>
                </Tabs>
            </Modal>
        </div>
    )
}

export default ReportContentModalView;